import { render, staticRenderFns } from "./TournamentEdit.vue?vue&type=template&id=48f8bf00&scoped=true&"
import script from "./TournamentEdit.vue?vue&type=script&lang=js&"
export * from "./TournamentEdit.vue?vue&type=script&lang=js&"
import style0 from "./TournamentEdit.vue?vue&type=style&index=0&id=48f8bf00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f8bf00",
  null
  
)

component.options.__file = "TournamentEdit.vue"
export default component.exports